import z from "zod";

export const projectContactFormSchema = z.object({
	contactId: z.uuid(),
	contactMemberIds: z.array(z.uuid()),
});

export type ProjectContactFormSchema = z.infer<typeof projectContactFormSchema>;
